import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./SwalService.scss";

export const SwalServices = withReactContent(Swal);

const customClass = {
  container: "",
  popup: "",
  header: "",
  title: "",
  closeButton: "",
  icon: "",
  image: "",
  htmlContainer: "",
  input: "",
  inputLabel: "",
  validationMessage: "",
  actions: "",
  confirmButton: "btn theme-button",
  denyButton: "btn dark-btn",
  cancelButton: "btn dark-btn",
  loader: "",
  footer: "",
  timerProgressBar: "",
};
const SwalAlert = () => {
  const success = (text, title) => {
    return SwalServices.fire({
      title: title,
      text: text,
      icon: "success",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
    });
  };

  const error = (text, title) => {
    return SwalServices.fire({
      title: title,
      text: text,
      icon: "error",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
    });
  };

  const warning = (text, title) => {
    return SwalServices.fire({
      title: title,
      text: text,
      icon: "warning",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
    });
  };

  const info = (title, text) => {
    return SwalServices.fire({
      title: title,
      text: text,
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
    });
  };

  const confirm = (title, text, saveBtnText, cancelBtnText, isCancelButton) => {
    return SwalServices.fire({
      title: title,
      text: text,
      icon: "question",
      // iconHtml: '<span className="warning-icons"><img src="/warningtick.png"/></span>',
      showCancelButton: isCancelButton === false ? isCancelButton : true,
      confirmButtonText: saveBtnText,
      cancelButtonText: cancelBtnText,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
      customClass: customClass,
    }).then((result) => {
      if (result.value) {
        return true;
      } else if (result.dismiss === SwalServices.DismissReason.cancel) {
        return false;
      }
    });
  };

  const confirmWithTextarea = (title, labelText, placeholderText, validationText, saveBtnText, cancelBtnText) => {
    return SwalServices.fire({
        title: title,
        input: "textarea",
        inputLabel: labelText || "",
        inputPlaceholder: placeholderText || "Type your message here...",
        inputAttributes: {
            "aria-label": "Type your message here"
        },
        showCancelButton: true,
        confirmButtonText: saveBtnText,
        cancelButtonText: cancelBtnText,
        allowOutsideClick: false,
        allowEscapeKey: true,
        customClass: customClass,
        preConfirm: (inputValue) => {
            if (!inputValue.trim()) {
                      SwalServices.showValidationMessage(validationText);
                return false;            }
            return inputValue;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // If the user confirmed, return the input value along with isConfirmed = true
          return { inputText: result.value, isConfirmed: true };
        } else if (result.dismiss === SwalServices.DismissReason.cancel) {
          // If the user canceled, return isConfirmed = false and inputText = null or false
          return { inputText: false, isConfirmed: false };
        }
      });
};


  // Export the SwalService functions
  return { confirm, success, warning, info, error,confirmWithTextarea };
};

export default SwalAlert;
